import { render } from "./personalDocuments.vue?vue&type=template&id=4e7a7113&scoped=true"
import script from "./personalDocuments.vue?vue&type=script&lang=js"
export * from "./personalDocuments.vue?vue&type=script&lang=js"

import "./personalDocuments.vue?vue&type=style&index=0&id=4e7a7113&scoped=true&lang=css"

import exportComponent from "../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e7a7113"]])

export default __exports__